import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "ArrowLeft",
  "use": "ArrowLeft-usage",
  "viewBox": "0 0 18 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 36\" id=\"ArrowLeft\"><path d=\"M18 3.731L7.17 18.001 18 32.269 13.66 36 0 18 13.66 0 18 3.731z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol